import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CompleteOnboardingMutationVariables = Types.Exact<{
  firstName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  lastName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  organizationName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  has3dExperience?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  newsletterOptIn?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  emailNotifications?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CompleteOnboardingMutation = { __typename: 'Mutation', completeOnboarding: { __typename: 'CompleteOnboardingResult', success: boolean, user: { __typename: 'SignupUserInfo', uuid: string, email: string, firstName?: string | null, lastName?: string | null, isActive: boolean, isOnboardingCompleted: boolean, ssoProvider?: string | null, has3dExperience?: boolean | null, newsletterOptIn?: boolean | null, emailNotifications?: boolean | null } } };

export type SaveOnboardingProgressMutationVariables = Types.Exact<{
  firstName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  lastName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  organizationName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  has3dExperience?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  newsletterOptIn?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type SaveOnboardingProgressMutation = { __typename: 'Mutation', saveOnboardingProgress: boolean };

export const CompleteOnboardingDocument = gql`
    mutation completeOnboarding($firstName: String, $lastName: String, $organizationName: String, $has3dExperience: Boolean, $newsletterOptIn: Boolean, $emailNotifications: Boolean) {
  completeOnboarding(
    firstName: $firstName
    lastName: $lastName
    organizationName: $organizationName
    has3dExperience: $has3dExperience
    newsletterOptIn: $newsletterOptIn
    emailNotifications: $emailNotifications
  ) {
    success
    user {
      uuid
      email
      firstName
      lastName
      isActive
      isOnboardingCompleted
      ssoProvider
      has3dExperience
      newsletterOptIn
      emailNotifications
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteOnboardingGQL extends Apollo.Mutation<CompleteOnboardingMutation, CompleteOnboardingMutationVariables> {
    override document = CompleteOnboardingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveOnboardingProgressDocument = gql`
    mutation saveOnboardingProgress($firstName: String, $lastName: String, $organizationName: String, $has3dExperience: Boolean, $newsletterOptIn: Boolean) {
  saveOnboardingProgress(
    firstName: $firstName
    lastName: $lastName
    organizationName: $organizationName
    has3dExperience: $has3dExperience
    newsletterOptIn: $newsletterOptIn
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveOnboardingProgressGQL extends Apollo.Mutation<SaveOnboardingProgressMutation, SaveOnboardingProgressMutationVariables> {
    override document = SaveOnboardingProgressDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }